import React from 'react';
import PollingQuestionList from '../MeetingDrawer/polling/addedQuestionsList/PollingQuestionList';

function WebPolling(props)
{
	const { setSideComp, handleClose } =props;

	return (
		<div className='flexCol fullH'>
			<PollingQuestionList webinarUser setSideComp={setSideComp} toggleToolArea={handleClose} handleClose={handleClose} />
		</div>
	);
}

export default WebPolling;